<div class="main-content">
  <div class="container-fluid">
    <div class="row">
        <div class="col-xs-12 col-sd-12 col-md-12 col-lg-12">
            <ng-content></ng-content>
        </div>
    </div>
  </div>
</div>
